import { useState } from 'react';
import { Head } from 'vite-react-ssg';
import { RiMailCheckLine } from 'react-icons/ri';
import { FaWhatsapp } from 'react-icons/fa';
import { FiCopy, FiCheck } from 'react-icons/fi';
import { WA_NUMBER } from '../constant/detail';

const Contact = () => {
  const [copied, setCopied] = useState(false);
  const email = 'suryajayateknik58@gmail.com';

  const handleCopy = () => {
    navigator.clipboard.writeText(email).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // reset after 2 seconds
    });
  };

  return (
    <div className="container mx-auto mt-16">
      <Head>
        <title>Kontak Pool Shop Bali | Surya Jaya Teknik Gianyar Ubud</title>
        <meta
          name="description"
          content="Hubungi Pool Shop Surya Jaya Teknik Bali via WhatsApp atau email. Toko di Ubud & Lodtunduh, Gianyar. Konsultasi gratis seputar kolam renang. Respon cepat!"
        />
        <link
          rel="canonical"
          href="https://poolshopsuryajayateknik.com/contact"
        />
        <meta
          property="og:title"
          content="Kontak Pool Shop Bali | Surya Jaya Teknik Gianyar Ubud"
        />
        <meta
          property="og:description"
          content="Hubungi Pool Shop Surya Jaya Teknik Bali via WhatsApp atau email. Toko di Ubud & Lodtunduh, Gianyar. Konsultasi gratis."
        />
        <meta
          property="og:url"
          content="https://poolshopsuryajayateknik.com/contact"
        />
        <meta property="og:type" content="website" />
      </Head>
      <section className="flex flex-col justify-center items-center mt-10 h-full">
        <RiMailCheckLine className="w-96 h-56 mb-10" />

        <h3>
          <span className="text-red-500">*</span>
          WA : 08123618911
        </h3>

        <button className="bg-green-500 text-white shadow-md rounded flex justify-center items-center p-1 mt-2 mb-2">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={`https://wa.me/${WA_NUMBER}?text=Order:`}
            className="flex items-center"
          >
            Contact Whatsapp
            <FaWhatsapp className="w-8 h-8 ml-2 text-white" />
          </a>
        </button>

        <div className="flex items-center space-x-3">
          <h3>Email: {email}</h3>
          <button
            onClick={handleCopy}
            className="flex items-center px-2 py-1 rounded hover:bg-gray-200"
            title="Copy to clipboard"
            aria-label="Salin alamat email"
          >
            {copied ? (
              <FiCheck className="text-green-600 w-5 h-5" />
            ) : (
              <FiCopy className="w-5 h-5" />
            )}
          </button>
        </div>
      </section>
    </div>
  );
};

export default Contact;
